export default function calculateTax(cartItems, TAX_RATE) {
  let tax = 0;
  let sliceCount = 0;

  const patisserieSubcategories = [
    "cookie",
    "cupcake",
    "cheesecakeSlice",
    "cakeSlice",
    "pastry",
    "macaron",
  ];

  cartItems.forEach((item) => {
    const { category, subcategory, unitPrice, quantity, type } = item;
    const lineTotal = unitPrice * quantity;
    let isTaxable = false;

    if (
      category === "accessory" ||
      category === "grazeBox" ||
      (category === "add-on" && type === "accessory") // taxing accessory add-ons like candles, text piping, etc.
    ) {
      isTaxable = true;
    }

    if (
      category === "specialtyCake" ||
      category === "standardCake" ||
      category === "cheesecake"
    ) {
      isTaxable = false;
    }

    if (patisserieSubcategories.includes(subcategory)) {
      sliceCount += quantity;
      return;
    }

    if (isTaxable) {
      tax += lineTotal * TAX_RATE;
    }
  });

  if (sliceCount > 0 && sliceCount < 6) {
    cartItems.forEach((item) => {
      if (patisserieSubcategories.includes(item.subcategory)) {
        tax += item.unitPrice * item.quantity * TAX_RATE;
      }
    });
  }

  return parseFloat(tax.toFixed(2));
}
